<template>
  <div class="flex items-center justify-center gap-2">
    <div class="flex flex-col glass-frosted rounded-8xl w-83 h-67.5 p-4">
      <div class="h-6 shrink-0">
        <Button color="blue2" size="xs" @click="handleBack">
          <Icon icon="Direction-Wireframe-Left2" />
          <span>{{ t('itinerary.calibrationPanel.backToItinerary') }}</span>
        </Button>
      </div>
      <div class="flex-1 w-full flex flex-col items-center justify-center gap-4">
        <img width="235" height="85" :src="calibrationImg" />
        <p class="text-m-medium text-black-white">
          {{ t('itinerary.calibrationPanel.introTip') }}
        </p>
      </div>
    </div>
    <div class="p-4 flex flex-col glass-frosted rounded-8xl w-174.5 h-67.5">
      <div class="h-11">
        <p class="text-l-semibold text-black-white">{{ t('itinerary.calibrationPanel.title') }}</p>
        <p class="text-s-medium text-text-glass-default leading-5">
          {{ t('itinerary.calibrationPanel.instructionPrefix') }}
          <span class="text-black-white">
            【{{ t('itinerary.calibrationPanel.startCalibration') }}】
          </span>
          {{ t('itinerary.calibrationPanel.instructionMiddle') }}
          <span class="text-green-active">
            {{ t('itinerary.calibrationPanel.instructionSuccess') }}
          </span>
          {{ t('itinerary.calibrationPanel.instructionSuffix') }}
          <span class="text-black-white">
            【{{ t('itinerary.calibrationPanel.saveCalibration') }}】
          </span>
        </p>
      </div>
      <div class="pb-3.5 flex-1 flex flex-col gap-2 items-center justify-end">
        <p v-if="startCalibration" class="text-s-medium text-text-glass-default">
          {{ t('itinerary.calibrationPanel.calibrationHint') }}
        </p>
        <Button
          color="glass"
          active
          size="lg"
          class="w-101"
          :class="startCalibration && 'bg-green-100'"
          @click="handleCalibrate"
        >
          <Icon icon="Technology-Wireframe-Calibrate" class="w-6 h-6" />
          <span>
            {{
              !startCalibration
                ? t('itinerary.calibrationPanel.startCalibration')
                : t('itinerary.calibrationPanel.saveCalibration')
            }}
          </span>
        </Button>
      </div>
    </div>
    <div class="flex flex-col justify-between glass-frosted rounded-8xl w-73.5 h-67.5 p-4">
      <div>
        <div class="flex justify-between items-center">
          <p class="text-l-semibold text-black-white">
            {{ t('itinerary.calibrationPanel.adaptiveTitle') }}
          </p>
          <Switch v-model="switchAdaptive" @update:model-value="switchAdaptiveCalibration" />
        </div>
        <p class="text-s-medium text-text-glass-default">
          {{ t('itinerary.calibrationPanel.adaptiveDescription') }}
        </p>
      </div>
      <div class="flex items-center text-s-medium text-brand-red">
        <Icon icon="Function-Fill-Close" class="w-4 h-4" />
        <span>{{ t('itinerary.calibrationPanel.adaptiveWarning') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Button, Icon, Switch } from '@rapoo/element'
  import { useLocaleStore } from '@/stores'
  import { useCalibrationMode } from '../composables/useCalibrationMode'

  import calibrationImg from '@/assets/images/devices/itinerary/calibration.png'

  const emits = defineEmits<{
    (e: 'update:mode', mode: 'calibration' | 'demo'): void
  }>()
  const { t } = useLocaleStore()

  const {
    switchAdaptive,
    startCalibration,
    switchAdaptiveCalibration,
    calibration,
    saveCalibration,
    calibratedKeys,
  } = useCalibrationMode()

  const handleCalibrate = () => {
    if (startCalibration.value) {
      saveCalibration()
    } else {
      calibration()
    }
  }

  const handleBack = () => {
    calibratedKeys.value = []
    emits('update:mode', 'demo')
  }
</script>

<style scoped></style>
